'use client';

import ArrowLong from '@/assets/svg/ArrowLong';
import ArrowRight from '@/assets/svg/ArrowRight';
import { cn } from '@/lib/utils';
import { Project } from '@/types/project';
import Image from 'next/image';
import Link from 'next/link';



interface Props {
  data: Project;
  index?: number;
  onlyImage?: boolean;
}



export default function Card({ data, index, onlyImage = false }: Props) {
  return (
    <div className={cn('h-full text-[#101011]  rounded-3xl overflow-hidden w-full max-w-[388px]')}>
      <div className='relative h-full'>
        {/*<AspectRatio ratio={4 / 3}>*/}
        <Image
          src={data.mainImg?.url}
          width={data.mainImg.width}
          height={data.mainImg.height}
          className='w-full object-cover 2xl:h-[340px] h-[228px] sm:h-[278px]'
          alt=''
          onContextMenu={(e) => e.preventDefault()}
          unoptimized
        />
        {/*</AspectRatio>*/}
        {!onlyImage && (
          <div className='px-4 flex bg-[#EEEEEE] flex-col gap-4 justify-between min-h-[177px] h-[calc(100%-340px)] pt-6 pb-4'>
            <div className='flex flex-col gap-2'>
              <div className='flex 2xl:text-[22px] text-[18px] leading-[120%] tracking-normal sm:text-lg font-bold sm:text-[18px]'>
                {data.name}
              </div>
              <div className='w-full 2xl:text-[14px] text-[9px] font-poppins leading-[120%] tracking-normal font-normal uppercase sm:text-[11.46px]'>
                {data.tags
                  .slice(0, 3)
                  .map((i) => i.name)
                  .join(', ')}
              </div>
            </div>
            { data.slug &&
              <Link href={data.slug}>
                <div className='flex w-full justify-between flex-wrap gap-y-4 lg:flex-col'>
                <div className='rounded-3xl flex items-center 2xl:gap-6 gap-4 border border-[#101011] px-3'>
                  <p className='uppercase font-poppins 2xl:text-[13px] text-[8.5px] sm:text-[10.64px] sm:align-middle leading-[120%] tracking-normal align-middle sm:text-xs'>
                    Details
                  </p>
                  <div className='2xl:h-6 2xl:w-9 w-[24px] h-4 sm:h-[17px] sm:w-[30px] sm:h-[20px]'>
                    <ArrowLong className='sm:fill-[#101011]' />
                  </div>
                </div>
              </div>
              </Link>
            }
          </div>
        )}
      </div>
    </div>
  );
}



export function InfoCard({ data, index, onlyImage = false }: Props) {
  return (
    <div className={cn('h-auto flex-1 text-[#101011] relative rounded-3xl overflow-hidden max-w-[388px]')}>
      <div className='relative h-full'>
        {/*<AspectRatio ratio={4 / 3}>*/}
        <Image
          src={data.mainImg?.url}
          width={data.mainImg.width}
          height={data.mainImg.height}
          className='w-full object-cover 2xl:h-[340px] h-[228px] sm:h-[278px]'
          alt=''
          onContextMenu={(e) => e.preventDefault()}
          unoptimized
        />
        {/*</AspectRatio>*/}
        {!onlyImage && (
          <div className='px-4 flex bg-[#EEEEEE] flex-col gap-4 justify-between min-h-[177px] pt-6 pb-4 h-full'>
            <div className='flex flex-col gap-2'>
              <div className='flex 2xl:text-[22px] text-[18px] leading-[120%] tracking-normal sm:text-lg font-bold sm:text-[18px]'>
                {data.name}
              </div>
              <div className='flex 2xl:text-[14px] text-[12px] leading-[120%] tracking-normal sm:text-lg'>
                <div
                  className="break-words"
                  dangerouslySetInnerHTML={{ __html: data.slug ?? '' }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
